import { render } from "./AddContrat.vue?vue&type=template&id=377dc2eb&ts=true"
import script from "./AddContrat.vue?vue&type=script&lang=ts"
export * from "./AddContrat.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__